<template>
    <!-- DESKTOP -->
    <div v-if="!isMobile && imageComparisonEnabled" id="lock-picture" @click="toggleLock">
        <div class="button">
            <icon v-if="isLocked" name="lock" scale="1.2" />
            <icon v-else name="unlock" scale="1.2" />
        </div>
    </div>

    <!-- MOBILE -->
    <div v-else-if="imageComparisonEnabled" id="mobile-lock-picture">
        <div :class="[imageComparisonEnabled ? 'd-flex' : 'd-none']" class="lock-picture-button justify-content-center align-items-center" @click="toggleLock">
            <icon v-if="isLocked" name="lock" color="white" scale="1.2" />
            <icon v-else name="unlock" color="white" scale="1.2" />
        </div>
    </div>
</template>

<script>
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/unlock'

export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false,
        },

        imageComparisonEnabled: {
            type: Boolean,
        },

        isLocked: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toggleLock() {
            this.$emit('onLockChanged', !this.isLocked)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/lock-picture.scss';
</style>
